import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Announcement } from './types/announcement.model';
import { PressService } from '../press.service';
import { LoggingService } from 'app/wipperoz-core/services/logging.service';

@Component({
  selector: 'app-announcements',
  templateUrl: './announcements.component.html',
  styleUrls: ['./announcements.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AnnouncementsComponent implements OnInit, OnDestroy {
  announcements: Announcement[] = [];
  startAnnouncements = 0;
  endAnnouncements = 10;
  step = 10;
  showLoadMore = false;
  loading = false;
  private unsubscribeAll: Subject<any>;

  constructor(private pressService: PressService, private loggingService: LoggingService) {
    this.unsubscribeAll = new Subject();
  }
  ngOnDestroy(): void {
    this.unsubscribeAll.next(null);
    this.unsubscribeAll.complete();
  }

  ngOnInit(): void {
    this.pressService.onAnnouncementChanged.pipe(takeUntil(this.unsubscribeAll)).subscribe(
      (data) => {
        if (data.length > 0) {
          this.showLoadMore = true;
          if (this.startAnnouncements === 0) {
            this.announcements = data;
          } else {
            this.announcements.push(...data);
          }
        } else {
          this.showLoadMore = false;
        }
        this.loading = false;
      },
      (err) => {
        this.loading = false;
        this.loggingService.logError('Error getting announcements content', JSON.stringify(err));
      }
    );
    this.pressService.getAnnouncements(this.startAnnouncements, this.endAnnouncements);
  }
  onLoadMore(): void {
    if (!this.loading) {
      this.startAnnouncements = this.endAnnouncements + 1;
      this.endAnnouncements = this.endAnnouncements + this.step;
      this.loading = true;
      this.pressService.getAnnouncements(this.startAnnouncements, this.endAnnouncements);
    }
  }
}
